import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { ChangeVatDeclarationPayload, changeVatDeclarationPeriod } from '../query-api'

interface UseChangeVatDeclarationPeriodProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export interface ChangeVatDeclarationPeriodPayload {
  vatDeclarationId: string
  payload: ChangeVatDeclarationPayload
}

export const useChangeVatDeclarationPeriod = (props?: UseChangeVatDeclarationPeriodProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: changePeriod, isLoading: isProcessing } = useMutation(
    ({ vatDeclarationId, payload }: ChangeVatDeclarationPeriodPayload) =>
      changeVatDeclarationPeriod(vatDeclarationId, payload),
    {
      onError,
      onSuccess,
    },
  )

  return { isProcessing, changePeriod }
}
